import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Regexs } from '@utils/regex';

@Component({
  selector: 'app-origen-asignacion-caso-investigacion',
  templateUrl: './origen-asignacion-caso-investigacion.component.html',
  styleUrls: ['./origen-asignacion-caso-investigacion.component.scss'],
})
export class OrigenAsignacionCasoInvestigacionComponent implements OnInit {
  form: FormGroup;

  @Input() data: { task: any };

  constructor(private fb: FormBuilder) {}

  typeCaseOptions = [
    'Estafa',
    'Extravio de Teléfono',
    'Infidelidad de empleado',
    'TDC no bloqueada',
    'Incumplimiento de procedimientos',
    'Incumplimiento del Código de Ética',
    'Irregularidades Administrativas',
    'Reposo forjado',
    'Retiro de TDD ',
    'Transferencias fraudulentas',
    'Uso Indebido De Los Recursos Del Banco ',
    'Forjamiento de documento',
    'Diferencia faltante en caja',
    'Retiro Indebido',
    'Debitos no Reconocidos en Cuenta',
    'Deposito Indebido',
    'Entrega indebida de TDD',
    'Computadora Extraviada',
    'Debitos no reconocidos en cuentas ',
    'Elaboración de cheque de Gerencia sin autorización',
    'Falta de probidad',
    'Fraude por compra de dólares',
    'Hurto de teléfono',
    'Manejo Irregular de dinero, ingreso no justificado',
    'Operativa inuasual ',
    'Abonos Indebidos ',
    'Faltante en boveda  ',
    'Saboteo a instalaciones electricas',
    'Retiro indebido en cuenta de ahorros',
    'Entrega de TDD Irregular ',
    'Retiro no reconocido en cuenta.',
    'Consultas indebidas',
  ];
  check: boolean;
  ngOnInit(): void {
    const { task } = this.data;
    const values = task.data ? task.data : null;
    this.form = this.fb.group({
      check: [values ? values.check : false, []],
      codigo_agencia: [values ? values.codigo_agencia : '', []],
      sake: [values ? values.sake : '', [Validators.pattern(/^[0-9]\d*$/)]],
      ci_empleado: [values ? values.ci_empleado : '', []],
      empleado: [values ? values.empleado : '', []],
      cargo: [values ? values.cargo : '', []],
      cliente: [values ? values.cliente : '', []],
      ci_cliente: [
        values ? values.ci_cliente : '',
        [, Validators.pattern(Regexs.regexCiRif)],
      ],
      cuenta: [
        values ? values.cuenta : '',
        [, Validators.pattern(Regexs.regexAccountNumber)],
      ],
      involucrado: [values ? values.involucrado : '', []],
      ci_involucrado: [
        values ? values.ci_involucrado : '',
        [, Validators.pattern(Regexs.regexCiRif)],
      ],
      denuncia: [values ? values.denuncia : '', []],
      fecha_evento: [values ? values.fecha_evento : '', [Validators.required]],
      tipo_caso: [values ? values.tipo_caso : '', []],
      monto_riesgo: [
        values ? values.monto_riesgo : '',
        [Validators.pattern(Regexs.regexAmount)],
      ],
      monto_recuperado: [
        values ? values.monto_recuperado : '',
        [Validators.pattern(Regexs.regexAmount)],
      ],
      descripcion: [values ? values.descripcion : '', []],
    });
  }

  verificateInput(value: string) {
    return (
      this.form.get(value)?.invalid &&
      (this.form.get(value)?.dirty || this.form.get(value)?.touched)
    );
  }
}
